// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"3364edb9","275":"5c702af5","429":"1b23a211","734":"a83b0ccc","739":"0605553d","851":"1cff5f85","887":"71ddc611","981":"3364edb9"}[chunkId] + ".chunk.css";
};